import type { WebapiEndpointBuilder } from '@/api/webapi.ts';
import type { BlotterTradeEntry } from '@/store/blotter/api/types/BlotterTradeEntry.ts';

export type BlotterTodayTradesListQueryPayload = {
  showMyMainDeals: boolean;
};

export const todayTradesList = (builder: WebapiEndpointBuilder) => {
  return builder.query<BlotterTradeEntry[], BlotterTodayTradesListQueryPayload>({
    // we need to disable caching for this query, it populates blotter grids at start and whenever filtering changes and new trades show up any time
    keepUnusedDataFor: 0,
    query: (body) => ({
      url: '/blotter/todayTradesList',
      method: 'POST',
      body,
      headers: {
        Accept: '*/*', // will respond with a string of the json-serialized payload if we give "Accept: application/json" (true story)
      },
    }),
  });
};
